import { ServiceType } from 'src/pages/ServiceMaintenance/enums'
import { FullMaintenanceProps } from 'src/api/Maintenance/types'

export enum SortStates {
  BY_NEW = 'BY_NEW',
  BY_ODOMETER = 'BY_ODOMETER',
  BY_TOTAL_COST = 'BY_TOTAL_COST',
  BY_DETAILS = 'BY_DETAILS',
}

export type Comparator = (
  a: FullMaintenanceProps,
  b: FullMaintenanceProps,
) => number

export type ListSorts = {
  type: SortStates
  title: string
}

export type MaintenanceFilters = {
  minOdometer: number | null
  maxOdometer: number | null
  serviceType: ServiceType | null
  minTotalCost: number | null
  maxTotalCost: number | null
}
